import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {EstoqueService} from "../../services/estoque.service";
import {UnidadeMedidaUtils} from "../UnidadeMedidaUtils";
import {PrevisaoFinanceiraMovimentacao} from "./PrevisaoFinanceiraMovimentacao";

@Component({
  selector: 'app-form-movimentacao-insumo',
  templateUrl: './form-movimentacao-insumo.component.html',
  styleUrls: ['./form-movimentacao-insumo.component.scss']
})
export class FormMovimentacaoInsumoComponent implements OnInit, OnDestroy {
  @Input() varios  = false;
  @Input() movimentacao: any = {};
  @Output() onSalvou: any =   new EventEmitter();
  @Output() onCancelou: any =   new EventEmitter();
  @ViewChild('frmM', {static: false}) frmM: NgForm;
  salvando = false;
  movimentacoes: any = [];
  mensagemErro: string;
  motivosMovimentacao   = [ ]
  tipoSelecionado: 'entrada' | 'saida' = null;
  controleCustoEstoqueAtivo = false;
  carregandoStatusControleCusto = true;
  resultadoBeneficiamento: any;
  previaBeneficiamento: any;
  carregandoPreviaBeneficiamento = false;
  erroPreviaBeneficiamento: any;
  private timerPreviaBeneficiamento: any;
  private versaoPreviaBeneficiamento = 0;
  constructor(private estoqueService: EstoqueService) { }

  ngOnInit(): void {
    delete this.mensagemErro;
    this.salvando = false;
    this.movimentacao.horario = new Date();
    this.tipoSelecionado = this.movimentacao.motivoDaMovimentacao
      ? this.movimentacao.motivoDaMovimentacao.tipo
      : null;
    if(this.varios)
      this.movimentacoes.push({ insumo: null, quantidade: null})

    this.estoqueService.obtenhaStatusControleCustoEstoque().then((status: any) => {
      this.controleCustoEstoqueAtivo = !!status.ativo;
      this.carregandoStatusControleCusto = false;
    }).catch((erro: any) => {
      this.carregandoStatusControleCusto = false;
      this.mensagemErro = erro;
    });

    this.estoqueService.listeMotivosMotimentacoes( ).then( (resposta: any) => {
      this.motivosMovimentacao = resposta;
    });

  }

  ngOnDestroy(): void {
    if(this.timerPreviaBeneficiamento)
      clearTimeout(this.timerPreviaBeneficiamento);
    this.versaoPreviaBeneficiamento++;
  }

  obtenhaMotivos( ){
    let beneficado = this.movimentacao.insumo  && this.movimentacao.insumo.tipo === 'produto-beneficiado';

    if(this.varios || beneficado ) return  this.motivosMovimentacao;

    return  this.motivosMovimentacao.filter((item: any) => !item.paraInsumoBeneficado)

  }

  motivosDoTipo(): any[] {
    if(!this.tipoSelecionado)
      return [];
    return this.obtenhaMotivos().filter(
      (item: any) => item.tipo === this.tipoSelecionado
    );
  }

  iconeDoMotivo(motivo: any): string {
    const iconesPorMotivo: any = {
      3: 'fas fa-industry',
      4: 'fas fa-clipboard',
      5: 'fas fa-clipboard',
      6: 'fas fa-sliders-h',
      7: 'fas fa-sliders-h',
      8: 'fas fa-exclamation-triangle'
    };
    return iconesPorMotivo[Number(motivo && motivo.id)] || 'fas fa-exchange-alt';
  }

  alterouTipo(tipo: 'entrada' | 'saida'): void {
    this.tipoSelecionado = tipo;
    delete this.movimentacao.motivoDaMovimentacao;
    delete this.movimentacao.justificativa;
    this.limpeDadosDependentesDoMotivo();
    this.agendePreviaBeneficiamento();
  }


  alterouMotivo(motivoDaMovimentacao: any) {
    this.movimentacao.motivoDaMovimentacao = motivoDaMovimentacao;
    this.limpeDadosDependentesDoMotivo();
    if(!this.exigeJustificativa())
      delete this.movimentacao.justificativa;
    if(this.varios){
      if(motivoDaMovimentacao.paraInsumoBeneficado){
        this.movimentacoes.forEach((item: any) => {
           if(item.insumo && item.insumo.tipo !== 'produto-beneficiado'){
             item.insumo = null
           }
        })
      }
    }
    this.agendePreviaBeneficiamento();

  }

  entradaPorBenefiamento(){
    return  this.movimentacao.motivoDaMovimentacao?.id === 3
  }

  onSalvarMovimentacao(){
    if(this.frmM.valid){
      this.salvando = true;

      if(this.varios){
        let dados: any = Object.assign({}, this.movimentacao)
        dados.insumos = this.movimentacoes.map(item => this.prepareItemParaEnvio(item));

        this.estoqueService.registreMovimentacoesManual(dados).then((resposta) => {
          this.salvando = false;
          this.onSalvou.emit( )
        }).catch((err) => {
          this.mensagemErro = err
          this.salvando = false;
        })
      } else {
        const dados = Object.assign({}, this.movimentacao, this.prepareItemParaEnvio(this.movimentacao));
        this.estoqueService.registreMovimentacaoManual(dados).then((resposta: any) => {
          this.movimentacao.insumo.estoque =      resposta.insumo.estoque
          if(this.entradaPorBenefiamento())
            this.resultadoBeneficiamento = resposta;
          this.salvando = false;
          this.onSalvou.emit(this.movimentacao)
        }).catch((err) => {
          this.mensagemErro = err
          this.salvando = false;
        })
      }
    }
  }


  canceleMovimentacao(){
    this.onCancelou.emit({})
  }


  obtenhaFormato(){
    return this.obtenhaFormatoDoInsumo(this.movimentacao.insumo)
  }

  obtenhaFormatoDoInsumo(insumo: any){
    return UnidadeMedidaUtils.obtenhaFormatoItem(insumo)
  }

  obtenhaDescricaoUnidade(insumo: any){
    return UnidadeMedidaUtils.obtenhaDescricaoUnidade(insumo)
  }

  novaMovimentacao() {
    this.movimentacoes.push({})
    this.agendePreviaBeneficiamento();
  }

  removaMovimentacao(i: number) {
    this.movimentacoes.splice(i, 1);
    this.agendePreviaBeneficiamento();
  }

  alterouInsumoDaMovimentacao(): void {
    this.agendePreviaBeneficiamento();
  }

  obtenhaConsumoIgredimente(dataItem: any, ingrediente: any){
    let rendimento:  number = dataItem.quantidade  /  dataItem.insumo.receita?.rendimento;

    rendimento = Number((rendimento * ingrediente.quantidade).toFixed(2));

    return `${rendimento} ${this.obtenhaDescricaoUnidade(dataItem.insumo)}`
  }

  tipoMovimentacao(): string {
    return this.movimentacao.motivoDaMovimentacao && this.movimentacao.motivoDaMovimentacao.tipo;
  }

  entradaComCustoInformado(): boolean {
    return this.controleCustoEstoqueAtivo && this.tipoMovimentacao() === 'entrada' &&
      !this.entradaPorBenefiamento();
  }

  saidaComCustoCalculado(): boolean {
    return this.controleCustoEstoqueAtivo &&
      (this.tipoMovimentacao() === 'saida' || this.tipoMovimentacao() === 'devolucao');
  }

  exigeJustificativa(): boolean {
    const id = Number(this.movimentacao.motivoDaMovimentacao && this.movimentacao.motivoDaMovimentacao.id);
    return this.controleCustoEstoqueAtivo && [6, 7, 8].indexOf(id) >= 0;
  }

  alterouQuantidade(item: any, valor: number): void {
    item.quantidade = valor;
    if(item._fonteCusto === 'total' && item.custoTotal != null)
      PrevisaoFinanceiraMovimentacao.sincronizePorTotal(item, item.custoTotal);
    else if(item.custoUnitario != null)
      PrevisaoFinanceiraMovimentacao.sincronizePorUnitario(item, item.custoUnitario);
    this.agendePreviaBeneficiamento();
  }

  alterouCustoUnitario(item: any, valor: number): void {
    PrevisaoFinanceiraMovimentacao.sincronizePorUnitario(item, valor);
  }

  alterouCustoTotal(item: any, valor: number): void {
    PrevisaoFinanceiraMovimentacao.sincronizePorTotal(item, valor);
  }

  custoTotalPrevisto(item: any): number | null {
    return PrevisaoFinanceiraMovimentacao.custoTotalPrevisto(
      item,
      this.tipoMovimentacao(),
      this.entradaPorBenefiamento()
    );
  }

  custoMedioAtual(item: any): number | null {
    const estoque = item && item.insumo && item.insumo.estoque;
    return !estoque || estoque.custoMedio == null ? null : Number(estoque.custoMedio);
  }

  custoDesconhecido(item: any): boolean {
    return this.saidaComCustoCalculado() && this.custoMedioAtual(item) === null;
  }

  private limpeDadosDependentesDoMotivo(): void {
    this.itensDaMovimentacao().forEach((item: any) => {
      delete item.custoUnitario;
      delete item.custoTotal;
      delete item._fonteCusto;
    });
    delete this.resultadoBeneficiamento;
    delete this.previaBeneficiamento;
    delete this.erroPreviaBeneficiamento;
  }

  private agendePreviaBeneficiamento(): void {
    this.versaoPreviaBeneficiamento++;
    const versao = this.versaoPreviaBeneficiamento;
    if(this.timerPreviaBeneficiamento)
      clearTimeout(this.timerPreviaBeneficiamento);

    delete this.previaBeneficiamento;
    delete this.erroPreviaBeneficiamento;
    this.carregandoPreviaBeneficiamento = false;

    const itens = this.itensParaPreviaBeneficiamento();
    if(!itens)
      return;

    this.carregandoPreviaBeneficiamento = true;
    this.timerPreviaBeneficiamento = setTimeout(() => {
      this.estoqueService.prevejaBeneficiamento(itens).then((previa: any) => {
        if(versao !== this.versaoPreviaBeneficiamento)
          return;
        const itensDaTela = this.itensDaMovimentacao();
        previa.itens.forEach((item: any) => {
          const itemDaTela = itensDaTela.find(
            (movimentacao: any) => Number(movimentacao.insumo.id) === Number(item.idInsumo)
          );
          item.insumo = itemDaTela && itemDaTela.insumo;
        });
        this.previaBeneficiamento = previa;
        this.carregandoPreviaBeneficiamento = false;
      }).catch((erro: any) => {
        if(versao !== this.versaoPreviaBeneficiamento)
          return;
        this.erroPreviaBeneficiamento = erro;
        this.carregandoPreviaBeneficiamento = false;
      });
    }, 400);
  }

  private itensParaPreviaBeneficiamento(): any[] | null {
    if(!this.entradaPorBenefiamento())
      return null;
    const itens = this.itensDaMovimentacao();
    if(!itens.length || itens.some((item: any) =>
      !item.insumo || !item.insumo.id || !(Number(item.quantidade) > 0)))
      return null;
    return itens.map((item: any) => ({
      insumo: {id: item.insumo.id},
      quantidade: item.quantidade
    }));
  }

  private itensDaMovimentacao(): any[] {
    return this.varios ? this.movimentacoes : [this.movimentacao];
  }

  private prepareItemParaEnvio(item: any): any {
    return PrevisaoFinanceiraMovimentacao.prepareItemParaEnvio(
      item,
      this.tipoMovimentacao(),
      this.entradaPorBenefiamento()
    );
  }
}
